import styled from 'styled-components';
import warning from '../assets/img/warning.png';
import { BlankSpace } from './layouts';

export default function CardWarning({ text }:{text:string}) {
  return (
    <CadrWarningContainer>
      <img src={warning} width={14} height={14} alt="" />
      <BlankSpace width="15px" />
      {text}
    </CadrWarningContainer>
  );
}

const CadrWarningContainer = styled.div`
  max-width: 100%;
  background-color: #FFFAF2;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 5px 5px;
  margin: 0px 0px 0px 0px;
  font-size: 10px;
  color: #6C6C6C;
`;
